import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";

export const FeaturesMultiEdit: FC = () => {
  const { t } = useTranslation("dialogs");

  return (
    <SimpleDialogFallback
      context={{
        maxWidth: "50.5rem",
        title: t("featuresMultiEdit.setValues"),
      }}
    />
  );
};
